import { QuickResolveActionItem } from '@hakimo-ui/hakimo/types';
import { Button } from '@hakimo-ui/shared/ui-base';
import { XMarkIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { getQuickResolveActionLabel } from '../sop-manager/type-guards';

interface Props {
  onClose: () => void;
  actionWithSubactions: QuickResolveActionItem;
  subActions: string[];
  onSubActionClick: (subAction: string) => void;
  isLoading: boolean;
}

export function ResolveSubActions(props: Props) {
  const {
    onClose,
    actionWithSubactions,
    subActions,
    onSubActionClick,
    isLoading,
  } = props;

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-onlight-text-1 dark:text-ondark-text-1 text-base font-semibold">
          Resolve the alarm
        </h2>
        <Button variant="icon" onClick={onClose} title="Close">
          <XMarkIcon className="h-5 w-5" />
        </Button>
      </div>

      <div className="space-y-3">
        <h3 className="text-onlight-text-2 dark:text-ondark-text-2 text-sm font-semibold">
          {getQuickResolveActionLabel(actionWithSubactions)}
        </h3>
        <div className="flex flex-wrap gap-2">
          {subActions.map((subAction, i) => (
            <button
              key={i}
              type="button"
              onClick={() => onSubActionClick(subAction)}
              disabled={isLoading}
              className={clsx(
                'rounded-full border px-3 py-1.5 text-xs font-medium transition-colors',
                'focus-visible:ring-primary-500 dark:ring-offset-dark-bg focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
                'border-onlight-line-3 dark:border-ondark-line-3 text-onlight-text-2 dark:text-ondark-text-2 hover:border-primary-500 hover:bg-primary-50 dark:hover:border-primary-500 dark:hover:bg-primary-900/20 bg-transparent',
                isLoading && 'cursor-not-allowed opacity-50'
              )}
            >
              {subAction}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
